import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, getCustomerData, fetchSampleTypes, proceedsamplerequestorder } from '../../Service/ApiService';
import { useLocation } from 'react-router-dom';
import { showAlert } from 'utils/ErrorMessage';
import { showSuccessAlert } from 'utils/SuccessMessage';
import * as Yup from "yup";

const barcodeItemSchema = Yup.object().shape({
  sampleType: Yup.object()
    .nullable()
    .required("Sample type is required"),

  sampleQuantity: Yup.mixed()
    .required("Quantity is required")
    .test(
      "is-valid-number",
      "Quantity must be at least 1",
      (value) => {
        if (value === null || value === undefined || value === "") return false;
        return Number(value) >= 1;
      }
    )
});

const SampleSelectionController = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const incomingData = location.state?.barcodeData || [];

  const [sampleTypes, setSampleTypes] = useState([]);
  const [selectedSampleType, setSelectedSampleType] = useState(null);
  const [sampleCategory, setSampleCategory] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchText, setSearchText] = useState('');

  const [barcodeData, setBarcodeData] = useState(() =>
    (incomingData || []).map(item => ({ ...item, sampleType: item.sampleType, sampleQuantity: item.sampleQuantity ?? null }))
  );

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const confvalue = JSON.parse(localStorage.getItem("confvalue")) || {};

  // Remark
  //const [sampleRequestOrderId, setampleRequestOrderId] = useState(null);
  const [openRemarkDialog, setOpenRemarkDialog] = useState(false);
  const [remark, setRemark] = useState('');
  const [remarkError, setRemarkError] = useState("");

  const barcodeArraySchema = Yup.array().of(barcodeItemSchema);

  useEffect(() => {
    getSampleTypes();
  }, []);

  useEffect(() => {
    getCustomerDetails(user.userCode, searchText);
  }, [searchText]);


  useEffect(() => {
    console.log('customerOptions updated:', customerOptions);
  }, [customerOptions]);

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const getCustomerDetails = async (userCode, searchText) => {
    if (searchText && searchText.length < 3) {
      return;
    }

    try {
      const res = await getCustomerData(userCode, searchText);
      if (res && res.success == "true") {
        const options = (res.customerList || []).reduce((uniqueList, customer) => {
          const existingCustomer = uniqueList.find((item) => item.value === customer.partyCode);

          if (!existingCustomer) {
            uniqueList.push({
              value: customer.partyCode,
              label: `${customer.partyName} - ${customer.city} - ${customer.partyCode}`,
              apId: customer.apId
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(options);
      } else {
        setCustomerOptions([]);
      }
    } catch (err) {
      console.error("Customer Details load error:", err);
      return null;
    }
  };

  const getSampleTypes = async () => {
    try {
      const res = await fetchSampleTypes();
      if (res && res.success == "true") {
        const sampleTypeOptions = res.activeConferenceList.map(item => ({
          value: item.sampleTypeId,
          label: item.sampleTypeName
        }));

        setSampleTypes(sampleTypeOptions);
      } else {
        setSampleTypes([]);
      }
    } catch (err) {
      console.error("Sample Types load error:", err);
      return [];
    }
  };

  const setBarcodeSampleType = (index, sampleTypeOption) => {
    setBarcodeData(prev =>
      prev.map((item, i) =>
        i === index
          ? {
            ...item,
            sampleType: sampleTypeOption,
            errors: { ...item.errors, sampleType: "" } // clear error
          }
          : item
      )
    );
  };


  const setBarcodeSampleQuantity = (index, sampleQuantity) => {
    setBarcodeData(prev =>
      prev.map((item, i) =>
        i === index
          ? {
            ...item,
            sampleQuantity: sampleQuantity,
            errors: { ...item.errors, sampleQuantity: "" } // clear error
          }
          : item
      )
    );
  };


  // const submitSampleRequest = async () => {
  //   try {
  //     if (!sampleCategory) {
  //       showAlert("Please select sample category");
  //       return;
  //     }

  //     if (!selectedCustomer) {
  //       showAlert("Please select party");
  //       return;
  //     }

  //     console.log('Submitting sample request with barcodeData:', barcodeData);

  //     const userCode = user?.userCode;
  //     const conferenceId = confvalue?.cID;
  //     const apId = selectedCustomer?.apId || '';
  //     const partyCode = selectedCustomer?.value || '';

  //     // incoming barcode data passed from prev screen
  //     const incomingData = location.state?.barcodeData || [];

  //     // build sample details
  //     const SampleOrderDetails = barcodeData
  //       .filter(item => item.sampleType && item.sampleQuantity > 0)
  //       .map((item, i) => ({
  //         sampleType: item.sampleType.label,
  //         quantity: item.sampleQuantity,

  //         // merge material fields from incomingData
  //         materialID: incomingData[i]?.materialID || "",
  //         materialCode: incomingData[i]?.materialCode || "",
  //         materialDesc: incomingData[i]?.materialDesc || "",
  //         mainGroup: incomingData[i]?.mainGroup || "",
  //         materialVertical: incomingData[i]?.materialVertical || "",
  //         barcode: incomingData[i]?.barcode || ""
  //       }));

  //     // validation
  //     const valid = await validateBarcodeItems();
  //     if (!valid) {
  //       showAlert("Please fix highlighted errors");
  //       return;
  //     }

  //     const payload = {
  //       userCode,
  //       apId,
  //       partyCode,
  //       conferenceId,
  //       sampleCategory,
  //       sampleOrderDetailsListArray: {
  //         SampleOrderDetails
  //       }
  //     };

  //     const response = await proceedsamplerequestorder(payload);
  //     if (response.success === 'true') {
  //       setampleRequestOrderId(response.samReqOrderId ?? null);
  //       // showSuccessAlert("Bill Details Uploaded Successfully!", "Successfully Uploaded");
  //       setOpenRemarkDialog(true);
  //       console.log("API RESPONSE →", response);
  //     }

  //     return;
  //   } catch (err) {
  //     showAlert("Sample request not submitted!");
  //   }
  // };

  // // Remark
  // const submitRemark = async () => {
  //   try {
  //     const response = await submitSampleRequestRemarkAPI(sampleRequestOrderId, remark);
  //     if (response.success) {
  //       showSuccessAlert("Remark Submitted Successfully!", "Remark Submitted");
  //       setOpenRemarkDialog(false);
  //       setTimeout(() => {
  //         navigate("/sample-request-dashboard");
  //       }, 500);
  //     }

  //     return;
  //   } catch (err) {
  //     showAlert("Remark not submitted!");
  //   }
  // }

  const submitSampleRequest = async () => {
    try {
      if (!sampleCategory) {
        showAlert("Please select sample category");
        return;
      }

      if (!selectedCustomer) {
        showAlert("Please select party");
        return;
      }

      const valid = await validateBarcodeItems();
      if (!valid) {
        showAlert("Please fix highlighted errors");
        return;
      }

      setOpenRemarkDialog(true);
    } catch (err) {
      showAlert("Something went wrong while validating!");
    }
  };

  const submitRemark = async () => {
    try {
      // optional: make remark mandatory
      if (!remark.trim()) {
        setRemarkError("Please enter a remark");
        return;
      }

      setRemarkError("");

      const userCode = user?.userCode;
      const conferenceId = confvalue?.cID;
      const apId = selectedCustomer?.apId || '';
      const partyCode = selectedCustomer?.value || '';

      console.log('Submitting sample request with barcodeData:', barcodeData);

      const SampleOrderDetails = barcodeData
        .filter(item => item.sampleType && item.sampleQuantity > 0)
        .map((item, i) => ({
          sampleType: item.sampleType.label,
          quantity: item.sampleQuantity,

          materialID: incomingData[i]?.materialID || "",
          materialCode: incomingData[i]?.materialCode || "",
          materialDesc: incomingData[i]?.materialDesc || "",
          mainGroup: incomingData[i]?.mainGroup || "",
          materialVertical: incomingData[i]?.materialVertical || "",
          barcode: incomingData[i]?.barcode || ""
        }));

      const payload = {
        userCode,
        apId,
        partyCode,
        conferenceId,
        sampleCategory,
        remark,
        sampleOrderDetailsListArray: {
          SampleOrderDetails
        }
      };

      const response = await proceedsamplerequestorder(payload);

      if (response.success === 'true' || response.success === true) {
        showSuccessAlert("Sample request submitted successfully!", "Successfully Submitted");
        // 🔽 DOWNLOAD FILE HERE
        // assuming API returns fileUrl or filePath
        downloadFile(`${response.samReqDocNo}.pdf`);

        setOpenRemarkDialog(false);
        setTimeout(() => {
          navigate("/view-sample-request");
        }, 500);
      } else {
        showAlert(response.message || "Sample request not submitted!");
      }

      return;
    } catch (err) {
      console.error(err);
      showAlert("Sample request not submitted!");
    }
  };

  const downloadFile = (fileName) => {
    if (!BASE_URL || !fileName) return;

    const fileUrl = `${BASE_URL}uploads/sample_request/${fileName}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName; // suggested filename
    link.target = "_blank";   // optional but safe
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };




  const validateBarcodeItems = async () => {
    try {
      await barcodeArraySchema.validate(barcodeData, { abortEarly: false });

      // Clear old errors
      setBarcodeData(prev =>
        prev.map(item => ({ ...item, errors: {} }))
      );

      return true;
    } catch (err) {
      if (!err.inner) return false;

      const updated = [...barcodeData];

      err.inner.forEach(e => {
        const match = e.path.match(/\[(\d+)\]/);
        if (!match) return;

        const index = Number(match[1]);
        const field = e.path.split(".")[1]; // "sampleType" or "sampleQuantity"

        if (!updated[index].errors) updated[index].errors = {};
        updated[index].errors[field] = e.message;
      });

      setBarcodeData(updated);
      return false;
    }
  };


  return {
    barcodeData,
    sampleTypes,
    selectedSampleType,
    setSelectedSampleType,
    customerOptions,
    selectedCustomer,
    setSelectedCustomer,
    sampleCategory,
    setSampleCategory,
    setBarcodeSampleType,
    setBarcodeSampleQuantity,
    submitSampleRequest,
    openRemarkDialog,
    setOpenRemarkDialog,
    remark,
    setRemark,
    remarkError,
    handleInputChange,
    submitRemark
  };
};

export default SampleSelectionController;
